import React, { Fragment } from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Chip from "@mui/material/Chip";
const useStyle = makeStyles(() => ({
  chip: {
    fontSize: 11,
    margin: 2
  },
  label: {
    wordBreak: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden"
  }
}));
const ChipsContainer = ({
  list,
  maxChip,
  chipMaxWidth = 100
}) => {
  const MAX_CHAR = 50;
  const MAX_CHIP = maxChip;
  let charecters = 0;
  let numChips = 0;
  const classes = useStyle(chipMaxWidth);
  const shortList = list.filter(item => {
    charecters += item.length;
    return charecters < MAX_CHAR && MAX_CHIP > numChips++;
  });
  return /*#__PURE__*/React.createElement(Fragment, null, shortList.map((item, index) => /*#__PURE__*/React.createElement(Chip, {
    classes: {
      label: classes.label
    },
    style: {
      maxWidth: chipMaxWidth === 0 ? "auto" : chipMaxWidth
    },
    key: index,
    size: "small",
    label: item,
    className: classes.chip
  })), list.length > shortList.length && /*#__PURE__*/React.createElement(Chip, {
    classes: {
      label: classes.label
    },
    size: "small",
    label: `+ ${list.length - shortList.length} More`,
    className: classes.chip
  }));
};
export default ChipsContainer;
ChipsContainer.propTypes = {
  list: PropTypes.array,
  maxChip: PropTypes.number,
  chipMaxWidth: PropTypes.number
};
ChipsContainer.defaultProps = {
  list: [],
  maxChip: 7
};